export default "__VITE_ASSET__D8E8H1gV__"